
import {defineComponent} from "vue";

export default defineComponent({
    name: "Radio",
    props: {
        headline: {
            type: String,
            required: false
        },
        options: {
            type: Array,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        labelAddition: {
            type: String,
            required: false
        },
        defaultOption: {
            type: Number,
            required: true
        },
    },
    emits: ['valueChanged'],
    data() {
        return {
            selectedOption: this.defaultOption,
            isInit: true
        }
    },
    watch: {
        //Ändert sich sobald die defaultOption von außen geladen wurde
        defaultOption() {
            this.selectedOption = this.defaultOption;
        },
        selectedOption() {
            if (!this.isInit) {//Der Wert wird erst aus der AEM-RechnerLib nachgeladen, hier soll noch keine Berechnung angetriggert werden.
                this.$emit('valueChanged', this.selectedOption);
            } else {
                this.isInit = false;
            }
        }
    }
})
